import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useToast } from 'components/ui/use-toast';
import { setQuestionReportStatus } from './api';
import type { QuestionReportStatus } from './constants';

/** Resolves, dismisses or reopens every report on one question, then refreshes every tab of the inbox. */
export function useSetQuestionReportStatus(testId: string) {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: ({ questionId, status }: { questionId: string; status: QuestionReportStatus }) =>
      setQuestionReportStatus(testId, questionId, status),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['questionReports', 'inbox'] });
    },
    onError: () => {
      toast.error(t('question_reports.status_error_title'), { description: t('question_reports.status_error_description') });
    },
  });
}
